import { configureStore } from '@reduxjs/toolkit'
import userReducer from 'store/slices/userSlice'
import captainsReducer from './slices/captainsSlice'


export default configureStore({
  reducer: {
    user: userReducer,
    captains: captainsReducer
  },
})
